import BordableModel from '../BordableModel';
import PropertyDescriptor from '../../utils/PropertyDescriptor';

export default class Model extends BordableModel {

    loadingBackgroundColor = new PropertyDescriptor('transparent', '加载时背景色', "边框与填充", "color", "#anticon-backgroundred", {
        gallery: "外观",
    });

    docId = new PropertyDescriptor("", "文档标识", "基本", "string", "#anticon-TrainTicket", {
        description: "需要呈现的大屏文档得标识",
    });

    dispatchInnerMessages = new PropertyDescriptor(false, "转发内部消息", "基本", "bool", "#anticon-noun_Soundwave_1786379", {
        description: "是否将大屏文档内部的消息转发到当前大屏中",
    });

    stretchToFit = new PropertyDescriptor(false, "拉伸填充", "布局", "bool", "#anticon-ZoomFit", {
        description: "强制将内容拉伸填充满整个部件",
    });

    overflowX = new PropertyDescriptor(false, '水平滚动', "布局", "bool", "#anticon-ui-scroll-pane-horiz", {
        description: "当子元素超出容器范围时，是否允许出现水平滚条",
    });

    overflowY = new PropertyDescriptor(false, '垂直滚动', "布局", "bool", "#anticon-ui-scroll-pane", {
        description: "当子元素超出容器范围时，是否允许出现垂直滚条",
    });

    constructor(opts = {}) {
        super();

        this.width.value = 600;
        this.height.value = 480;
        this.defineAllProperties();

        for (var p in opts) {
            this[p] = opts[p];
        }
    }

    getType() {
        return "DiagramViewerModel";
    }

    getDataContext() {
        return this.dataContext.data;
    }

    getInternalDataContext() {
        return this.dataContext.data;
    }

    getParentDataContext() {
        return super.getParentDataContext();
    }


    toStyle() {
        let style = super.toStyle();
        style.pointerEvents = "none";

        return style;
    }
}
